<template>
    <div>
        <b-row class="align-items-center">
            <b-col class="d-flex align-items-center col-lg-8 mb-1">
                <b-col>
                    <label for="matter-report-start-date-input"> {{ $t('invoiceDetailReport.start_date') }} </label>
                    <b-form-datepicker id="matter-report-start-date-input" today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('invoiceDetailReport.start_date')" size="sm" v-model="startDate" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                </b-col>
                <b-col>
                    <label for="matter-report-end-date-input"> {{ $t('invoiceDetailReport.end_date') }} </label>
                    <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('invoiceDetailReport.end_date')" size="sm" v-model="endDate" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                </b-col>
            </b-col>
            <b-col class="d-flex justify-content-end col-lg-4">
                <b-button  style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getInvoiceDetailReportList()" v-on:keyup.enter="getInvoiceDetailReportList()">{{ $t('others.search') }}</b-button>
                <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()" >{{ $t('excel.excel') }}</b-button>
            </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table id="matterReportTable" ref="matterReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, 
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, 
            selectAllByGroup: true, 
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'debitNo'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.debit_no') }}
                </span>
                <span v-else-if="props.column.field === 'accountNumber'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.account_number') }}
                </span>
                <span v-else-if="props.column.field === 'owner'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.owner') }}
                </span>
                <span v-else-if="props.column.field === 'agent'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.agent') }}
                </span>
                <span v-else-if="props.column.field === 'referenceNo'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.reference_no') }}
                </span>
                <span v-else-if="props.column.field === 'agentReference'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.agent_reference') }}
                </span>
                <span v-else-if="props.column.field === 'proformaDate'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.proforma_date') }}
                </span>
                <span v-else-if="props.column.field === 'invoiceDate'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.invoice_date') }}
                </span>
                <span v-else-if="props.column.field === 'invoiceNo'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.invoice_no') }}
                </span>
                <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.total') }}
                </span>
                <span v-else-if="props.column.field === 'currencyCode'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.currency_code') }}
                </span>
                <span v-else-if="props.column.field === 'department'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.department') }}
                </span>
                <span v-else-if="props.column.field === 'serviceType'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.service_type') }}
                </span>
                <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.description') }}
                </span>
                <span v-else-if="props.column.field === 'code'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.stock_code') }}
                </span>
                <span v-else-if="props.column.field === 'costingType'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.costing_type') }}
                </span>
                <span v-else-if="props.column.field === 'count'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.count') }}
                </span>
                <span v-else-if="props.column.field === 'unitPrice'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.unit_price') }}
                </span>
                <span v-else-if="props.column.field === 'discount'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.discount') }}
                </span>
                <span v-else-if="props.column.field === 'price'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.price') }}
                </span>
                <span v-else-if="props.column.field === 'type'" class="text-nowrap">
                    {{ $t('invoiceDetailReport.type') }}
                </span>
            </template>
    
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}</span>
                        <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total"  v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) =>props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
    </template>
    
      
    <script>
    export default {
        data() {
            return {
                dir: false,
                pageLength: 10,
                pageNo: 1,
                startDate: new Date(),
                endDate: new Date(),
                columns: [
                    {
                        label: this.$t('invoiceDetailReport.debit_no'),
                        field: `debitNo`
                    },
                    {
                        label: this.$t('invoiceDetailReport.account_number'),
                        field: `accountNumber`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.owner'),
                        field: `owner`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.agent'),
                        field: `agent`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.reference_no'),
                        field: `referenceNo`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.agent_reference'),
                        field: `agentReference`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.proforma_date'),
                        field: `proformaDate`,
                        formatFn: this.$formatFn
                    },
                    {
                        label: this.$t('invoiceDetailReport.invoice_date'),
                        field: `invoiceDate`,
                        formatFn: this.$formatFn
                    },
                    {
                        label: this.$t('invoiceDetailReport.invoice_no'),
                        field: `invoiceNo`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.total'),
                        field: `total`,
                        formatFn: this.$formatMoney,
                    },
                    {
                        label: this.$t('invoiceDetailReport.currency_code'),
                        field: `currencyCode`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.department'),
                        field: `department`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.service_type'),
                        field: `serviceType`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.description'),
                        field: `description`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.stock_code'),
                        field: `code`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.costing_type'),
                        field: `costingType`,
                    },
                    {
                        label: this.$t('invoiceDetailReport.count'),
                        field: `count`,
                        formatFn: this.$formatMoney,
                    },
                    {
                        label: this.$t('invoiceDetailReport.unit_price'),
                        field: `unitPrice`,
                        formatFn: this.$formatMoney,
                    },
                    {
                        label: this.$t('invoiceDetailReport.discount'),
                        field: `discount`,
                        formatFn: this.$formatMoney,
                    },
                    {
                        label: this.$t('invoiceDetailReport.price'),
                        field: `price`,
                        formatFn: this.$formatMoney,
                    },
                    {
                        label: this.$t('invoiceDetailReport.type'),
                        field: `type`,
                    },
                ],
                rows: [],
                searchTerm: '',
            }
        },
        methods: {         
            getInvoiceDetailReportList() {
                this.rows = []
                const controller = { name: 'Invoice', actionName: 'GetInvoiceDetailReportList' }
                const data = { pageLength: this.pageLength, pageNo: this.pageNo, startDate: this.startDate, endDate: this.endDate }
                const payload = { controller: controller, data : data }
                 let loader = this.$loading.show()
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        response.data.invoiceDetailReportList.forEach(element => {
                            this.rows.push(element)
                        })
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                     loader.hide()          
                })
            },
            exportExcel() {
                const controller = { name: 'Invoice', actionName: 'CanExport'}            
                const data = { columnList : this.columns, DataList : this.rows}
                const payload = { data : data, controller: controller}
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("Fatura_Detay_Raporu", response.data.base64, 'xlsx')
                    }
                    else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            }
        },
    }
    </script>
      
    <style lang="scss">
    .tableSize {
        font-size: 13px !important;
        border-collapse: collapse;
        width: 100%;
        max-width: 100%;
        table-layout: auto;
    }
    </style>
    